import apiClient from "../../utils/api.client";
import { formatDateJava } from "../../helpers/convertDate";
import { getNoaId, getOrganizationId } from "../../utils/session.utils";

const getTelekinoFiles = async (page, pageSize, sort) => {
  const organizationId = getNoaId();
  try {
    const url = `/delivery-service/files/pre-distribution/files/?organizationId=${organizationId}&pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderCriteria=${sort?.criteria || "DESC"}&orderField=${sort?.field || "processedDate"}`;
    const response = await apiClient(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getTelekinoFiles EP: ", error);
    throw error;
  }
};

const getTelekinoItems = async (fileId, page, pageSize, sort) => {
  const organizationId = getNoaId();
  try {
    const url = `/delivery-service/files/pre-distribution/items/?fileId=${fileId}&pageNumber=${page || 1}&pageSize=${pageSize || 100}&orderCriteria=${sort?.criteria || "DESC"}&orderField=${sort?.field || "nroDeAgencia"}`;
    const response = await apiClient(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getTelekinoFiles EP: ", error);
    throw error;
  }
};

const deleteTelekinoFile = async (id) => {
  try {
    const url = `/delivery-service/deliverynote/${id}`;
    const response = await apiClient.delete(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at deleteTelekinoFile EP: ", error);
    throw error;
  }
};

const postTxtFile = async (file) => {
  try {
    const url = `/delivery-service/files/pre-distribution`;
    const response = await apiClient.post(url, file, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      redirect: "follow",
    });
    const data = response.data;
    return data;
  } catch (error) {
    console.error("Error at postFile EP: ", error);
    throw error;
  }
};

const postGANSATxtFile = async (file) => {
  try {
    const organizationId = getNoaId();
    const url = `/delivery-service/files/winners-coupons/pre-printed?organizationId=${organizationId}`;
    const response = await apiClient.post(url, file, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      redirect: "follow",
    });
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at postGansaTxtFile EP: ", error);
    throw error;
  }
};

const getPrizesGanza = async (page, pageSize, sort) => {
  try {
    const { criteria, field } = sort;
    const organizationId = getNoaId();
    const url = `/delivery-service/files/winners-coupons/pre-printed/files?organizationId=${organizationId}&pageNumber=${page || 1}&pageSize=${pageSize || 20}&orderCriteria=${criteria || "DESC"}&orderField=${field || "processedDate"}`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getPrizesGaza EP: ", error);
    throw error;
  }
};

const deleteGansalFile = async (id) => {
  try {
    const url = `/delivery-service/files/winners-coupons/pre-printed/${id}`;
    const response = await apiClient.delete(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at deleteGansalFile EP: ", error);
    throw error;
  }
};

const getPrizesGanzaDetails = async (page, pageSize, raffleId) => {
  try {
    const url = `/delivery-service/prizes/getprizes?pageNumber=${page || 1}&pageSize=${pageSize || 1000}&orderCriteria=ASC&orderField=raffleId&raffleId=${raffleId}`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getPrizesGanzaDetails EP: ", error);
    throw error;
  }
};

const getDatabyId = async (id, page, pageSize) => {
  try {
    const url = `/delivery-service/deliverynote/file/files?id=${id}&pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderCriteria=ASC&orderField=processedFile`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getDataById EP: ", error);
    throw error;
  }
};

const confirmFile = async (id, organizationName) => {
  try {
    const noaId = getNoaId();
    const url = `delivery-service/deliverynote/comfirm-delivery-notes-for-file/${id}?organizationId=${noaId}&organizationName=${organizationName}`;
    const response = await apiClient.put(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at confirmFile EP: ", error);
    throw error;
  }
};

const getAllSalprem = async (page, pageSize, sort) => {
  try {
    const organizationId = getNoaId();
    const url = `delivery-service/files/prem/files?organizationId=${organizationId}&pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderCriteria=${sort?.criteria || "DESC"}&orderField=${sort?.field || "processedDate"}&includeDeleted=false`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getAllSalprem EP: ", error);
    throw error;
  }
};

const postPremFile = async (file) => {
  try {
    // WARNING: The organization Id must be the one from the noa
    const noaId = getNoaId();
    const url = `/delivery-service/files/prem?organizationId=${noaId}`;
    const response = await apiClient.post(url, file, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      redirect: "follow",
    });
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at postPremFile EP: ", error);
    throw error;
  }
};

const deleteSalpremFile = async (id) => {
  try {
    const url = `/delivery-service/files/prem/${id}`;
    const response = await apiClient.delete(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at deleteSlPremFile EP: ", error);
    throw error;
  }
};

const getAllVtaFiles = async (page, pageSize, sort) => {
  try {
    const noaId = getNoaId();
    const url = `/delivery-service/files/vta/files?organizationId=${noaId}&pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderCriteria=${sort?.criteria || "DESC"}&orderField=id`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getAllVtaFiles EP: ", error);
    throw error;
  }
};

const postVtaFile = async (file) => {
  try {
    const url = `/delivery-service/files/vta`;
    const response = await apiClient.post(url, file, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at postVtaFile EP: ", error);
    throw error;
  }
};
const deleteVtaFile = async (id) => {
  try {
    const url = `/delivery-service/files/vta/${id}`;
    const response = await apiClient.delete(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at deleteVtaFile EP: ", error);
    throw error;
  }
};

const createWinnerCouponPreimpreso = async (payload) => {
  try {
    const url = `/delivery-service/prizes/payments/preprinted`;
    const response = await apiClient.post(url, payload);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at createWinnerCouponPreimpreso EP: ", error);
    throw error;
  }
};

const modifyWinnerCouponPreimpreso = async (payload) => {
  try {
    const url = `/delivery-service/prizes/payments/preprinted`;
    const response = await apiClient.put(url, payload);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at modifyWinnerCouponPreimpreso EP: ", error);
    throw error;
  }
};

const createWinnerCouponInstantaneo = async (payload) => {
  try {
    const url = `/delivery-service/prizes/payments/instantaneous`;
    const response = await apiClient.post(url, payload);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at createWinnerCouponInstantaneo EP: ", error);
    throw error;
  }
};

const modifyWinnerCouponInstantaneo = async (payload) => {
  try {
    const url = `/delivery-service/prizes/payments/instantaneous`;
    const response = await apiClient.put(url, payload);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at modifyWinnerCouponInstantaneo EP: ", error);
  }
};

const getWinnerCoupon = async (page, pageSize, sort, filters) => {
  const orgId = getNoaId();

  try {
    const { coupon, gameId, dateFrom, dateTo, raffle, agencyId } = filters;
    const url = `/delivery-service/prizes/payments/?organizationId=${orgId}&pageNumber=${page || 1}&pageSize=${pageSize || 20}&orderCriteria=${sort?.criteria || "DESC"}&orderField=${sort?.field || "raffleId"}${coupon ? `&couponNumber=${coupon}` : ""}${dateFrom ? `&dateFrom=${formatDateJava(dateFrom).split("-").reverse().join("-")}` : ""}${dateTo ? `&dateTo=${formatDateJava(dateTo).split("-").reverse().join("-")}` : ""}${agencyId ? `&agencyId=${agencyId}` : ""}${gameId ? `&gameId=${gameId}` : ""}${raffle ? (raffle?.number ? `&raffleNumber=${raffle?.number}` : raffle?.serie ? `&raffleNumber=${raffle?.serie}` : "") : ""}`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getWinnerCoupon EP: ", error);
  }
};

//mayores tarasca
const getFilesTarasca = async (page, pageSize, sort) => {
  try {
    const organizationId = getNoaId();
    const url = `/delivery-service/files/winners-coupons/instants/files?organizationId=${organizationId}&pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderCriteria=${sort?.criteria}&orderField=${sort?.field || "processedDate"}`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getFilesTarasca EP: ", error);
    throw error;
  }
};

const uploadFileTarasca = async (file) => {
  try {
    const organizationId = getNoaId();
    const url = `/delivery-service/files/winners-coupons/instants?organizationId=${organizationId}`;
    const response = await apiClient.post(url, file, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      redirect: "follow",
    });
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at uploadFileTarasca EP: ", error);
    throw error;
  }
};

const getDetailTarascaFile = async (page, pageSize, fileId) => {
  try {
    const url = `/delivery-service/files/winners-coupons/instants/items?fileId=${fileId}&pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderCriteria=DESC&orderField=id`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getDetailTarascaFile EP: ", error);
    throw error;
  }
};

const deleteTarascaFile = async (id) => {
  try {
    const url = `/delivery-service/files/winners-coupons/instants/${id}`;
    const response = await apiClient.delete(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at deleteTarascaFile EP: ", error);
    throw error;
  }
};

const deletePrizePayment = async (id) => {
  try {
    const url = `/delivery-service/prizes/payments/${id}`;
    const response = await apiClient.delete(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at deletePrizPayment EP: ", error);
    throw error;
  }
};

const confirmTarascaFile = async (filename) => {
  try {
    const url = `/delivery-service/prizes/tarasca/activate?filename=${filename}`;
    const response = await apiClient.put(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at confirmTarascaFile EP: ", error);
    throw error;
  }
};

const getGansalDetail = async (page, pageSize, fileId) => {
  try {
    const url = `/delivery-service/files/winners-coupons/pre-printed/items?pageNumber=${page || 1}&pageSize=${pageSize || 10}&fileId=${fileId}`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    throw error;
  }
};

const getSalvtaDetail = async (page, pageSize, sort, fileId) => {
  try {
    const { criteria, field } = sort;
    const url = `/delivery-service/files/vta/items?pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderField=${field}&orderCriteria=${criteria}&fileId=${fileId}`;
    const response = await apiClient.get(url);
    console.log("RESPONSE");
    console.log(response);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getSalvtaDetil EP: ", error);
    throw error;
  }
};

const getSalpremDetail = async (page, pageSize, sort, fileId) => {
  try {
    const { criteria, field } = sort;
    const url = `/delivery-service/files/prem/items?pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderCriteria=${criteria || "ASC"}&orderField=${field || "agency"}&fileId=${fileId}`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getSalpremDetail EP: ", error);
    throw error;
  }
};

const putPremConciliation = async (fileId) => {
  try {
    const response = await apiClient.put(
      `/delivery-service/files/prem/conciliate/${fileId}`,
    );
    const data = response.data;

    return data;
  } catch (error) {
    console.log("Error at putPremConciliation ep", error);
    throw error;
  }
};

/* It confirms the pre-dist file
 *
 * @param {string} id - file id to validation
 */
const postPreDistributionValidate = async (id) => {
  try {
    const url = `/delivery-service/files/pre-distribution/validate/${id}`;
    const response = await apiClient.post(url);

    return response;
  } catch (error) {
    console.error("Error at posPreDistributionValidate", error);
    throw error;
  }
};

/* It confirms the pre-dist file
 *
 * @param {string} id - file id to validation
 */
const deletePreDistributionFile = async (id) => {
  try {
    const url = `/delivery-service/files/pre-distribution/${id}`;
    const response = await apiClient.delete(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at deleteTelekinoFile EP: ", error);
    throw error;
  }
};

const masiveDistributionServices = {
  getTelekinoFiles,
  getTelekinoItems,
  deleteTelekinoFile,
  postTxtFile,
  postGANSATxtFile,
  getPrizesGanza,
  deleteGansalFile,
  getPrizesGanzaDetails,
  getDatabyId,
  confirmFile,
  getAllSalprem,
  postPremFile,
  deleteSalpremFile,
  getAllVtaFiles,
  postVtaFile,
  deleteVtaFile,
  createWinnerCouponPreimpreso,
  modifyWinnerCouponPreimpreso,
  createWinnerCouponInstantaneo,
  modifyWinnerCouponInstantaneo,
  getWinnerCoupon,
  getFilesTarasca,
  uploadFileTarasca,
  getDetailTarascaFile,
  deleteTarascaFile,
  deletePrizePayment,
  confirmTarascaFile,
  getGansalDetail,
  getSalvtaDetail,
  getSalpremDetail,
  putPremConciliation,
  postPreDistributionValidate,
  deletePreDistributionFile,
};

export default masiveDistributionServices;
